/* unplugin-vue-components disabled */import script from "./myAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./myAlert.vue?vue&type=script&setup=true&lang=js"

import "./myAlert.vue?vue&type=style&index=0&id=9a8f6298&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a8f6298"]])

export default __exports__